import { ScrapSpec } from './scrap/scrap-spec'
import { ProcessingType } from '../processing-type/processing-type'
import { Duration, Period } from '@js-joda/core'
import { AttachmentSpec } from '../../attachments/spec/attachment-spec'
import { WorkItemMatcher } from '../../matcher/work-item-matcher'

export class WorkInstructionSpec {
  public taskName: string
  public taskDescription: string
  public attachmentSpecs: AttachmentSpec[] = []
}

export class OperationSegmentSpec {
  public action: string
  public instructions: WorkInstructionSpec[] = []
  public materialMappingSpec: MaterialMappingSpec = new MaterialMappingSpec()
}

export class MaterialMappingSpec {
  constructor(
    public consumptionMaterialPaths: string[] = [],
    public finishedMaterialPaths: string[] = [],
    public retainBomNames: boolean = false // feature flag
  ) {}
}

export class ProcessLeadTimeSpec {
  constructor(
    /**
     * The processing time of a product from start to finish.
     */
    public independentProcessingLeadTime: string,
    public dependantProcessingLeadTime: string
  ) {}
}

export class ProcessLeadTimeSpecUtils {
  public static calculateTotalIndependentLeadTime(spec: ProcessLeadTimeSpec): Period {
    return spec?.independentProcessingLeadTime
      ? Period.parse(spec.independentProcessingLeadTime)
      : Period.ZERO
  }

  public static calculateTotalDependentLeadTime(spec: ProcessLeadTimeSpec): Duration {
    return spec?.dependantProcessingLeadTime
      ? Duration.parse(spec.dependantProcessingLeadTime)
      : Duration.ZERO
  }
}

export class ProcessPlan {
  public id: string
  public name: string
  public processingType: ProcessingType
  public operations: OperationSegmentSpec[]
  public workItemMatcher: WorkItemMatcher
  public packagingSpec: PackagingSpec
  public labelingSpec: LabelingSpec
  public preparationSpec: PreparationSpec
  public displayProperties: string[]
  public processLeadTimeSpec: ProcessLeadTimeSpec
  public scrapSpecs: ScrapSpec[]
  public releaseAt: string

  constructor() {
    this.labelingSpec = new LabelingSpec()
    this.preparationSpec = new PreparationSpec()
    this.processLeadTimeSpec = new ProcessLeadTimeSpec(
      Period.ZERO.toString(),
      Duration.ZERO.toString()
    )
    this.scrapSpecs = []
    this.packagingSpec = new PackagingSpec(true)
  }
}

export class PreparationSpec {
  /**
   * Is external preparation enabled
   */
  public enabled: boolean
}

export class LabelingSpec {
  public itemLabel: LabelingSpecLabel
  public itemPieceLabel: LabelingSpecLabel

  constructor() {
    this.itemLabel = new LabelingSpecLabel()
    this.itemPieceLabel = new LabelingSpecLabel()
  }
}

export class LabelingSpecLabel {
  /**
   * Is labeling enabled
   */
  public enabled: boolean

  /**
   * Is labeling required
   */
  // private boolean required.

  /**
   * The label template name.
   *
   * A template denotes the design & layout of a document.
   *
   * However, a template can result in different documents
   * (such as pdf, html, zpl, post-script), depending on the desired
   * document format or an automatically derived required format.
   */
  public template: string
}

export class PackagingSpec {
  public packagingEnabled: boolean

  public supportedPackageTypes: string[]

  public defaultPackageType: string

  public packageCalculationPossible: boolean

  constructor(packagingEnabled: boolean) {
    this.packagingEnabled = packagingEnabled
  }
}
